import { render } from "./AdminOrderClientTracking.vue?vue&type=template&id=43a04423&ts=true&lang=true"
import script from "./AdminOrderClientTracking.vue?vue&type=script&lang=ts"
export * from "./AdminOrderClientTracking.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__